var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0329 9.12917L16.8663 3.9625L19.1996 1.62917C19.5774 1.25139 20.0441 1.0625 20.5996 1.0625C21.1552 1.0625 21.6218 1.25139 21.9996 1.62917L24.3663 3.99583C24.7441 4.37361 24.9329 4.84028 24.9329 5.39583C24.9329 5.95139 24.7441 6.41806 24.3663 6.79583L22.0329 9.12917ZM0.999609 24.9958V19.7958L7.46628 13.3292L0.0996094 5.92917L5.89961 0.0625L13.3329 7.49583L16.8663 3.9625L22.0329 9.12917L18.4996 12.6625L25.9329 20.0958L20.0996 25.8625L12.6996 18.4958L6.19961 24.9958H0.999609ZM8.89961 11.8958L11.8996 8.89583L9.46628 6.4625L7.86628 8.0625L6.46628 6.6625L8.06628 5.0625L5.93294 2.92917L2.93294 5.92917L8.89961 11.8958ZM20.0329 23.0625L23.0329 20.0625L20.8996 17.9292L19.2996 19.5292L17.8996 18.1292L19.4996 16.5292L17.0663 14.0958L14.0663 17.0958L20.0329 23.0625ZM2.99961 22.9958H5.33294L19.1663 9.1625L16.8329 6.82917L2.99961 20.6625V22.9958Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.fd4d1985eff65261de205c60d049076d.svg";
export { ForwardRef as ReactComponent };